<template>
  <div id="inst">
    <div class="inst">
      <div class="inst__step">
        <figure class="inst__step__header">
          <object :data="emptyStepOneSvg" type="image/svg+xml"></object>
        </figure>
        <div class="inst__step__content">
          <p class="inst__step__content__title">Haz tu selección de filtros</p>
          <p class="inst__step__content__text">Puedes elegir los filtros que más se ajusten a los prospectos que estás buscando.</p>
        </div>
      </div>

      <div class="inst__step">
        <figure class="inst__step__header">
          <object :data="emptyStepTwoSvg" type="image/svg+xml"></object>
        </figure>
        <div class="inst__step__content">
          <p class="inst__step__content__title">Vista previa del mensaje</p>
          <p class="inst__step__content__text">Verifica el mensaje que enviaremos a nuestros usuarios.</p>
        </div>
      </div>

      <div class="inst__step">
        <figure class="inst__step__header">
          <object :data="emptyStepThreeSvg" type="image/svg+xml"></object>
        </figure>
        <div class="inst__step__content">
          <p class="inst__step__content__title">Confirma tu selección</p>
          <p class="inst__step__content__text">Verifica que tu selección sea correcta y conoce cómo recibirás la información de los usuarios.</p>
        </div>
      </div>
    </div>

    <sm-button
      label="+ Hacer una búsqueda"
      size="medium"
      secondary
      @click="goToNextStep"
      class="inst__button"
    />
  </div>
</template>

<script>
import emptyStepOneSvg from '@/assets/empty-step-one.svg'
import emptyStepTwoSvg from '@/assets/empty-step-two.svg'
import emptyStepThreeSvg from '@/assets/empty-step-three.svg'

export default {
  name: 'Instructions',
  props: {
    msg: String
  },
  data () {
    return {
      emptyStepOneSvg,
      emptyStepTwoSvg,
      emptyStepThreeSvg
    }
  },
  methods: {
    goToNextStep () {
      this.$store.commit('goToNextStep')
    }
  }
}
</script>

<style>
#inst {
  margin-top: 30px;
  width: 100%;
}

.inst {
  align-items: flex-start;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  height: calc(100vh - 100px);
  justify-content: space-evenly;
  max-height: 600px;
  padding-top: 50px;
  width: 100%;
}

.inst__step__header__pic {
  border-color: #000000;
  border-style: solid;
  border-width: 1px;
  height: 200px;
  width: 200px;
}

.inst__step__header__number {
  color: #ffffff;
  font-size: large;
  font-weight: bold;
  line-height: 2;
  text-align: center;

  background-color: #00b19d;
  border-radius: 50%;
  height: 50px;
  height: fit-content;
  left: 55px;
  position: relative;
  top: -110px;
  width: 37px;
}
.inst__step__content__title {
  color: #00b19d;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;

  margin: 20px 0;
}

.inst__step__content {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.inst__step__content__text {
  font-size: 12px;
  font-weight: 100;

  width: 180px;
}

.inst__button {
  position: relative;
  top: -85px;
}

.inst__button:hover {
  background: rgba(0,83,94,0.93);
}
</style>
